// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M10.75 1.5C10.75 0.671573 11.4216 0 12.25 0C13.0784 0 13.75 0.671573 13.75 1.5V10H14.5V3.68609C14.5 2.85766 15.1716 2.18609 16 2.18609C16.8284 2.18609 17.5 2.85766 17.5 3.68609V10H18.25V7.02237C18.25 6.19416 18.9214 5.52275 19.7496 5.52275C20.5778 5.52275 21.2492 6.19416 21.2492 7.02237V15C21.2492 19.4183 17.6675 23 13.2492 23H11.8988C8.26329 23 5.08487 20.5486 4.1613 17.0323L2.66256 11.3262C2.47142 10.5985 2.79088 9.83284 3.44259 9.45678C4.22141 9.00736 5.21628 9.25578 5.69241 10.0186L7.00001 12.1133L7.00001 3.68609C7.00001 2.85766 7.67158 2.18609 8.50001 2.18609C9.32843 2.18609 10 2.85766 10 3.68609V10H10.75V1.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-gesture-ranslation-filled')
export default class GestureRanslationFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'gesture-ranslation-filled',
    }
  }
}
